/*!
* @copyright
* Copyright(c) 2018 SICK AG
*/
const style = `* {
  box-sizing: border-box;
}

*,
:host {
  box-sizing: border-box;
  font-size: 1rem;
  font-family: inherit;
}

:host button,
:host input,
:host optgroup,
:host select,
:host textarea {
  font-family: inherit;
}

:host {
  display: inline-block;
  vertical-align: middle;
  height: 3.2857142857rem;
  min-width: 10.7142857143rem;
  margin-top: 0.8571428571rem;
  background-color: #FFFFFF;
  background-color: var(--davinci-color-background-input, #FFFFFF);
  color: #2C3133;
  color: var(--davinci-color-text, #2C3133);
}
:host slot {
  display: none;
}
:host > .container {
  position: relative;
  display: flex;
  flex-direction: row;
  flex-wrap: nowrap;
  justify-content: flex-start;
  align-content: flex-start;
  align-items: center;
  background-color: var(--davinci-color-background-input,#FFFFFF);
  cursor: pointer;
  border: 1px solid var(--davinci-color-outline,#8E989D);
  height: 100%;
  width: 100%;
  padding: 0 0.8571428571rem 0 1.1428571429rem;
}
:host > .container > .dropdown-icon {
  margin-right: 0.5714285714rem;
}
:host > .container > .input {
  order: 0;
  flex: 1 1 auto;
  align-self: auto;
  display: none;
  border: none;
  height: 90%;
  font-size: inherit;
  min-width: 10px;
  text-overflow: ellipsis;
  background-color: #FFFFFF;
  background-color: var(--davinci-color-background-input, #FFFFFF);
  color: #2C3133;
  color: var(--davinci-color-text, #2C3133);
}
:host > .container > .input::-ms-clear {
  display: none;
}
:host > .container > .label {
  transition: all 150ms cubic-bezier(0.4, 0, 0.2, 1);
  position: absolute;
  font-size: inherit;
  left: 0;
  top: 0;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  color: #2C3133;
  color: var(--davinci-color-text, #2C3133);
  transform-origin: left top;
  transform: translate(0, -70%);
  font-size: 0.8571428571rem;
  line-height: 1.2857142857rem;
  background-color: #FFFFFF;
  background-color: var(--davinci-color-background, #FFFFFF);
  padding: 0 0.4285714286rem;
  margin-left: 0.7142857143rem;
  max-width: 90%;
}
:host > .container > .spinner {
  display: none;
  flex: 0 0 auto;
}
:host > .container > div.currentvalue {
  order: 0;
  flex: 1 1 auto;
  align-self: auto;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
  width: 0;
}
:host > .container > .dropdown-icon {
  order: 0;
  flex: 0 0 auto;
  align-self: auto;
  width: 1.7142857143rem;
  height: 1.7142857143rem;
  fill: #737F85;
  fill: var(--davinci-color-text-lighter, #737F85);
}
:host > .container > .expand-icon {
  order: 0;
  flex: 0 0 auto;
  align-self: auto;
  width: 1.7142857143rem;
  height: 1.7142857143rem;
  cursor: pointer;
  fill: #737F85;
  fill: var(--davinci-color-text-lighter, #737F85);
}
:host > .transformdetector {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  pointer-events: none;
}
:host > .overlaywrapper {
  position: fixed;
  top: 0;
  left: 0;
  bottom: 0;
  right: 0;
  display: none;
  pointer-events: none;
  z-index: 24;
}
:host > .overlaywrapper > .list {
  z-index: 8;
  box-shadow: 0.0714285714rem 0.1428571429rem 0.3571428571rem rgb(177, 184, 188);
  pointer-events: all;
  position: absolute;
  max-height: 21.4285714286rem;
  overflow: hidden;
  text-overflow: ellipsis;
  overflow-y: auto;
  background-color: #FFFFFF;
  background-color: var(--davinci-color-background-08dp, #FFFFFF);
  display: none;
}
:host > .overlaywrapper.expanded > .list, :host > .overlaywrapper.expanded {
  display: block;
}
:host > .overlaywrapper.expanded > .empty.list {
  display: none;
}
:host div.container:hover {
  border: 1px solid var(--davinci-color-primary,#007CC1) !important;
}
:host div.container:hover label.label {
  color: var(--davinci-color-primary,#007CC1) !important;
}
:host div.container:hover .expand-icon {
  fill: var(--davinci-color-primary,#007CC1) !important;
}

:host([editable]) > .container > input {
  display: block;
  outline: none;
}
:host([editable]) > .container > div {
  display: none;
}

:host(.focus-visible:focus-within),
:host(:focus-visible) {
  outline: none;
}
:host(.focus-visible:focus-within) .container,
:host(:focus-visible) .container {
  border: 1px solid var(--davinci-color-primary,#007CC1);
  background-color: var(--davinci-color-item-focus,#e5f6ff);
}
:host(.focus-visible:focus-within) .container input,
:host(:focus-visible) .container input {
  outline: none;
  background-color: var(--davinci-color-item-focus,#e5f6ff);
}
:host(.focus-visible:focus-within) .container .label,
:host(:focus-visible) .container .label {
  color: #007CC1;
  color: var(--davinci-color-primary, #007CC1);
}
:host(.focus-visible:focus-within) .container .expand-icon,
:host(:focus-visible) .container .expand-icon {
  fill: #007CC1;
  fill: var(--davinci-color-primary, #007CC1);
}

:host([label=""]) > .container > .label,
:host(:not([label])) > .container > .label {
  display: none;
}

:host([loading]) > .container > davinci-spinner {
  display: block;
}

:host(:not([disabled])) div.placeholder > div.currentvalue {
  color: #737F85;
  color: var(--davinci-color-text-lighter, #737F85);
}

:host([warning]:not([disabled])) div.container,
:host([warning]:not([disabled])) div.container.focus-within {
  border: 1px solid var(--davinci-color-warning,#F5C413);
}
:host([warning]:not([disabled])) div.container label.label,
:host([warning]:not([disabled])) div.container.focus-within label.label {
  color: #F5C413;
  color: var(--davinci-color-warning, #F5C413);
}
:host([warning]:not([disabled])) div.container .expand-icon,
:host([warning]:not([disabled])) div.container.focus-within .expand-icon {
  fill: #F5C413;
  fill: var(--davinci-color-warning, #F5C413);
}

:host([error]:not([disabled])) div.container,
:host([error]:not([disabled])) div.container.focus-within {
  border: 1px solid var(--davinci-color-error,#EA0823);
}
:host([error]:not([disabled])) div.container label.label,
:host([error]:not([disabled])) div.container.focus-within label.label {
  color: #EA0823;
  color: var(--davinci-color-error, #EA0823);
}
:host([error]:not([disabled])) div.container .expand-icon,
:host([error]:not([disabled])) div.container.focus-within .expand-icon {
  fill: #EA0823;
  fill: var(--davinci-color-error, #EA0823);
}

:host([disabled]) {
  pointer-events: none;
  color: #B1B8BC;
  color: var(--davinci-color-text-disabled, #B1B8BC);
}
:host([disabled]) .container {
  border-color: #C5CACC;
  border-color: var(--davinci-color-outline-light, #C5CACC);
}
:host([disabled]) .container .expand-icon {
  fill: #C5CACC;
  fill: var(--davinci-color-outline-light, #C5CACC);
}
:host([disabled]) .container ::-moz-placeholder {
  color: #B1B8BC;
  color: var(--davinci-color-text-disabled, #B1B8BC);
}
:host([disabled]) .container :-ms-input-placeholder {
  color: #B1B8BC;
  color: var(--davinci-color-text-disabled, #B1B8BC);
}
:host([disabled]) .container ::placeholder {
  color: #B1B8BC;
  color: var(--davinci-color-text-disabled, #B1B8BC);
}
:host([disabled]) .container .input {
  color: #B1B8BC;
  color: var(--davinci-color-text-disabled, #B1B8BC);
}
:host([disabled]) .container .label {
  color: #B1B8BC;
  color: var(--davinci-color-text-disabled, #B1B8BC);
}
:host([disabled]) .container .currentvalue {
  color: #B1B8BC;
  color: var(--davinci-color-text-disabled, #B1B8BC);
}
:host([disabled]) .container .currentvalue span {
  color: #B1B8BC;
  color: var(--davinci-color-text-disabled, #B1B8BC);
}

:host([hidden]) {
  display: none;
}`;
export { style };
